// @flow
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styles from './TermsOfServiceBanner.module.scss';
import Throbber from '@liveauctioneers/caterwaul-components/lib/Throbber/Throbber';

const tosLink = (
    <Link rel="noopener" target="_blank" to="/termsandconditions">
        <FormattedMessage id="terms_and_conditions" />
    </Link>
);
const privacyLink = (
    <Link rel="noopener" target="_blank" to="/privacy">
        <FormattedMessage id="privacy_policy" />
    </Link>
);
const cookieLink = (
    <Link rel="noopener" target="_blank" to="/cookie-policy">
        <FormattedMessage id="cookie_policy" />
    </Link>
);

type Props = {|
    submitConsent: Function,
    submitted: boolean,
|};

const TermsOfServiceBanner = (props: Props) => {
    const { submitConsent, submitted } = props;

    return (
        <div className={styles.banner}>
            <div className={styles['banner-inner']}>
                <div className={styles.text}>
                    <FormattedMessage id="terms_banner" values={{ cookieLink, privacyLink, tosLink }} />
                </div>
                <div>
                    <Button className={styles.submit} onClick={submitConsent} primary red>
                        {!submitted ? <FormattedMessage id="consent.agree" /> : <Throbber colorWhite />}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default React.memo<Props>(TermsOfServiceBanner, isEqual);
